import { axiosInstance as axios } from "services";

export const addUpdateCartingSeries = async (body) => {
  const isUpdate = body._id || body.id;
  const id = body._id || body.id;
  
  if (isUpdate) {
    const { data } = await axios.patch(`/pricing/master/carting/${id}`, body);
    if (!data.success) throw new Error(data.error?.message || "Failed to update carting");
    return data;
  } else {
    const { data } = await axios.post("/pricing/master/carting", body);
    if (!data.success) throw new Error(data.error?.message || "Failed to create carting");
    return data;
  }
};

